import { useMemo } from 'react';

import { useQueryAllPipelineTags } from '@ion/api';

import { usePipelinesTableContext } from 'app/pipelines/PipelinesTable/PipelinesTableContext';

const DEFAULT_PROPS = {
  size: 'small',
  variant: 'outlined',
  label: 'Tags',
  'data-test-id': 'pipelineTagSelect',
};

export default function usePipelineTagMultiSelectProps() {
  const { setTagIds } = usePipelinesTableContext();
  const { data: tags = [], loading } = useQueryAllPipelineTags();

  const options = useMemo(() => tags.map(tag => ({ label: tag.label, value: tag.id })), [tags]);

  return {
    ...DEFAULT_PROPS,
    options,
    loading,
    onChange: setTagIds,
    renderValue: selected => `Tags (${selected.length})`,
  };
}
